import projectService from "@/services/project.service"
import { acceptHMRUpdate, defineStore } from "pinia"
import { buildQueryString } from "@/services/utils"
import { ref } from "vue"

export const projectStates = {
  deleted: 0,
  paused: 1,
  active: 2
}
export const useProjectsStore = defineStore("projects", () => {
  const isOpenCreateModal = ref(false)
  const isOpenRenameModal = ref(false)
  const targetProject = ref(null)
  const projects = ref([])

  async function fetchTargetProject(uuid) {
    targetProject.value = uuid ? await projectService.getItem(uuid) : null
  }

  async function fecthProjects() {
    const { items } = await projectService.getCollection(null, {
      queryString: buildQueryString({ pagination: false })
    })
    projects.value = items
  }

  return {
    isOpenCreateModal,
    isOpenRenameModal,
    targetProject,
    projects,
    fetchTargetProject,
    fecthProjects
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useProjectsStore, import.meta.hot))
}
